import React, { memo } from 'react';
import styled from 'styled-components';
import Typography from '@material-ui/core/Typography';

interface ErrorTypographyProps {
    serverError: string
}

export const ErrorTypography = memo(({ serverError }: ErrorTypographyProps) => {
    return (
        <ErrorMessage align='center'>
            {serverError}
        </ErrorMessage>
    );
});

const ErrorMessage = styled(Typography)`
    color: #ff0000;
    font-size: 15px;
    margin: 0 auto; 
`;
